export enum DCGroupItemId {
  ForcedLevelComp = 'forcedLevelComp',
}
